import { useEffect, useRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { useLanguage } from "@/context/LanguageContext";

/**
 * 2026-06 · 采购可编辑字段（采购产品编号 / 起订量）— shared by the 采购询价链接页
 * and the 采购 view of a quote. Saves on blur / 700ms debounce.
 */
export default function BuyerItemFields({ item, onSave, requireMoq = false }) {
  const { t } = useLanguage();
  const [bin, setBin] = useState(item.buyer_item_number || "");
  const [moq, setMoq] = useState(item.moq || "");
  const timer = useRef(null);

  useEffect(() => {
    setBin(item.buyer_item_number || "");
    setMoq(item.moq || "");
  }, [item.buyer_item_number, item.moq]);

  const push = (fields) => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => onSave(fields), 700);
  };

  return (
    <div className="grid grid-cols-2 gap-3">
      <div>
        <p className="text-[10px] uppercase tracking-wide text-muted-foreground mb-1">{t("products.buyerItemNumber")}</p>
        <Input
          value={bin}
          onChange={(e) => { setBin(e.target.value); push({ buyer_item_number: e.target.value }); }}
          onBlur={() => onSave({ buyer_item_number: bin })}
          className="h-8 text-xs font-mono"
          data-testid={`buyer-field-bin-${item.item_number}`}
        />
      </div>
      <div>
        <p className="text-[10px] uppercase tracking-wide text-muted-foreground mb-1">
          {t("products.moq")}{requireMoq && <span className="text-destructive"> *</span>}
        </p>
        <Input
          value={moq}
          onChange={(e) => { setMoq(e.target.value); push({ moq: e.target.value }); }}
          onBlur={() => onSave({ moq })}
          placeholder={requireMoq ? t("procReq.moqRequired") : undefined}
          className={`h-8 text-xs ${requireMoq && !moq.trim() ? "border-destructive focus-visible:ring-destructive placeholder:text-destructive/70" : ""}`}
          data-testid={`buyer-field-moq-${item.item_number}`}
        />
      </div>
    </div>
  );
}
